import { ONE_HOUR_IN_MS, daysInMs, getTimeDifferenceInMilis } from '@/helpers/job-age';

type TranslationValues = {
  id: string;
  values?: Record<string, number>;
};

const getTranslationValues = (timeDifferenceInMilis: number): TranslationValues => {
  if (timeDifferenceInMilis < ONE_HOUR_IN_MS) {
    return { id: 'JOBS_TIMESTAMP_59_MINS_AGO_MAX' };
  }

  if (timeDifferenceInMilis <= daysInMs(1)) {
    return {
      id: 'JOBS_TIMESTAMP_BTW_60_MINS_&_24_HRS',
      values: { number: Math.floor(timeDifferenceInMilis / ONE_HOUR_IN_MS) },
    };
  }

  if (timeDifferenceInMilis <= daysInMs(2)) {
    return { id: 'JOBS_TIMESTAMP_BTW_24_HRS_&_48_HRS' };
  }

  if (timeDifferenceInMilis <= daysInMs(30)) {
    return {
      id: 'JOBS_TIMESTAMP_BTW_48_HRS_&_30_DAYS',
      values: { number: Math.floor(timeDifferenceInMilis / daysInMs(1)) },
    };
  }

  return { id: 'JOBS_TIMESTAMP_31_DAYS_AGO_MIN' };
};

export const getOptimisticPublicationDateI18n = (date: string): TranslationValues =>
  getTranslationValues(getTimeDifferenceInMilis(date));
